import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type FloorStoreState
 */
const initialState = {
  agreementList: { loading: false, data: null, error: null }, //list of signed agreemnet list
  agreementLog: { loading: false, data: null, error: null }, //list of signed agreemnet list
  createSmartSuiteAgreement: { loading: false, data: null, error: null }, // smart proposal create agreement(convert to deal)
  updateSmartSuiteAgreement: { loading: false, data: null, error: null },
  verifySmartSuiteAgreement: { loading: false, data: null, error: null },
  updateAgreementKycDocuments: { loading: false, data: null, error: null },
  updateAgreementSignedDocument: { loading: false, data: null, error: null },
  deleteSmartSuiteAgreement: { loading: false, data: null, error: null },
  expansionSmartSuiteAgreement: { loading: false, data: null, error: null },
  agrExpansionList: { loading: false, data: null, error: null },
  agreementById: { loading: false, data: null, error: null },
  createRenewalSmartSuiteAgreement: { loading: false, data: null, error: null },
  updateAgreementDocuments: { loading: false, data: null, error: null },
  agreementDocumentList: { loading: false, data: null, error: null },
  linkAgreementAccount: { loading: false, data: null, error: null },
  clientTicketsList: { loading: false, data: null, error: null },
  moveInEmailSend: { loading: false, data: null, error: null },
  isNoticeEmailSend: { loading: false, data: null, error: null },
  lienList :{loading:false,data: null, error: null},
  entityNames: { loading: false, data: null, error: null }, // distinct entity names for Strategy Details autocomplete
  agreementsByEntity: { loading: false, data: null, error: null }, // agreements grouped under a common entity name
  clientAgreementList: { loading: false, data: null, error: null } // agreements belonging to the same client (Linked Agreement table)
};
export const AgreementSlice = createSlice({
  name: "salutation",
  initialState,
  reducers: {
    fetchLienListRequest :(state,action)=>{
        state.lienList.loading = true;
        state.lienList.error = null;
    },
    fetchLienListSuccess:(state,action)=>{
       state.lienList.loading = false;
       state.lienList.data = action.payload;
       state.lienList.error = null;
    },
    fetchLienListError : (state,action)=>{
      state.lienList.loading = false;
      state.lienList.data = null;
      state.lienList.error = action.payload;
    },
    fetchEntityNamesRequest: (state, action) => {
      state.entityNames.loading = true;
      state.entityNames.error = null;
    },
    fetchEntityNamesSuccess: (state, action) => {
      state.entityNames.loading = false;
      state.entityNames.data = action.payload;
      state.entityNames.error = null;
    },
    fetchEntityNamesFailure: (state, action) => {
      state.entityNames.loading = false;
      state.entityNames.data = null;
      state.entityNames.error = action.payload;
    },
    fetchAgreementsByEntityRequest: (state, action) => {
      state.agreementsByEntity.loading = true;
      state.agreementsByEntity.error = null;
    },
    fetchAgreementsByEntitySuccess: (state, action) => {
      state.agreementsByEntity.loading = false;
      state.agreementsByEntity.data = action.payload;
      state.agreementsByEntity.error = null;
    },
    fetchAgreementsByEntityFailure: (state, action) => {
      state.agreementsByEntity.loading = false;
      state.agreementsByEntity.data = null;
      state.agreementsByEntity.error = action.payload;
    },
    fetchAgreementsByEntityReset: (state, action) => {
      state.agreementsByEntity.loading = false;
      state.agreementsByEntity.data = null;
      state.agreementsByEntity.error = null;
    },
    fetchClientAgreementListRequest: (state, action) => {
      state.clientAgreementList.loading = true;
      state.clientAgreementList.error = null;
    },
    fetchClientAgreementListSuccess: (state, action) => {
      state.clientAgreementList.loading = false;
      state.clientAgreementList.data = action.payload;
      state.clientAgreementList.error = null;
    },
    fetchClientAgreementListFailure: (state, action) => {
      state.clientAgreementList.loading = false;
      state.clientAgreementList.data = null;
      state.clientAgreementList.error = action.payload;
    },
    fetchClientAgreementListReset: (state, action) => {
      state.clientAgreementList.loading = false;
      state.clientAgreementList.data = null;
      state.clientAgreementList.error = null;
    },
    fetchSmartSuiteAgreementListRequest: (state, action) => {
      state.agreementList.loading = true;
      state.agreementList.error = null;
    },
    fetchSmartSuiteAgreementListSuccess: (state, action) => {
      state.agreementList.data = action.payload;
      state.agreementList.loading = false;
      state.agreementList.error = null;
    },
    fetchSmartSuiteAgreementListFaliure: (state, action) => {
      state.agreementList.data = null;
      state.agreementList.loading = false;
      state.agreementList.error = action.payload;
    },
    fetchAllSmartSuiteAgreementListRequest: (state, action) => {
      state.agreementList.loading = false;
      state.agreementList.error = null;
    },
    fetchAllSmartSuiteAgreementListSuccess: (state, action) => {
      state.agreementList.data = action.payload;
      state.agreementList.loading = false;
      state.agreementList.error = null;
    },
    fetchAllSmartSuiteAgreementListFaliure: (state, action) => {
      state.agreementList.data = null;
      state.agreementList.loading = false;
      state.agreementList.error = action.payload;
    },
    fetchSmartSuiteAgreementListRequestLog: (state, action) => {
      state.agreementLog.loading = true;
      state.agreementLog.error = null;
    },
    fetchSmartSuiteAgreementListLogSuccess: (state, action) => {
      state.agreementLog.data = action.payload;
      state.agreementLog.loading = false;
      state.agreementLog.error = null;
    },
    fetchSmartSuiteAgreementListLogFaliure: (state, action) => {
      state.agreementLog.data = null;
      state.agreementLog.loading = false;
      state.agreementLog.error = action.payload;
    },
    resetSmartSuiteAgreementListLog: (state, action) => {
      state.agreementLog.data = null;
      state.agreementLog.loading = false;
      state.agreementLog.error = null;
    },
    createSmartSuiteAgreementRequest: (state, action) => {
      state.createSmartSuiteAgreement.loading = true;
      state.createSmartSuiteAgreement.error = null;
    },
    createSmartSuiteAgreementSuccess: (state, action) => {
      state.createSmartSuiteAgreement.data = action.payload;
      state.createSmartSuiteAgreement.loading = false;
      state.createSmartSuiteAgreement.error = null;

      // state.agreementList = addSmartSuiteAgreementListSuccess(
      //   action.payload,
      //   state.agreementList
      // );
    },
    createSmartSuiteAgreementFailure: (state, action) => {
      state.createSmartSuiteAgreement.data = null;
      state.createSmartSuiteAgreement.loading = false;
      state.createSmartSuiteAgreement.error = action.payload;
    },
    createSmartSuiteAgreementReset: (state, action) => {
      state.createSmartSuiteAgreement.data = null;
      state.createSmartSuiteAgreement.loading = false;
      state.createSmartSuiteAgreement.error = null;
    },
    updateSmartSuiteAgreementRequest: (state, action) => {
      state.updateSmartSuiteAgreement.loading = true;
      state.updateSmartSuiteAgreement.error = null;
    },
    updateSmartSuiteAgreementSuccess: (state, action) => {
      state.updateSmartSuiteAgreement.data = action.payload;
      state.updateSmartSuiteAgreement.loading = false;
      state.updateSmartSuiteAgreement.error = null;

      state.agreementList = updateSmartSuiteAgreementListSuccess(
        action.payload,
        state.agreementList
      );
    },
    updateSmartSuiteAgreementFailure: (state, action) => {
      state.updateSmartSuiteAgreement.data = null;
      state.updateSmartSuiteAgreement.loading = false;
      state.updateSmartSuiteAgreement.error = action.payload;
    },
    updateSmartSuiteAgreementReset: (state, action) => {
      state.updateSmartSuiteAgreement.data = null;
      state.updateSmartSuiteAgreement.loading = false;
      state.updateSmartSuiteAgreement.error = null;
    },
    verifySmartSuiteAgreementRequest: (state, action) => {
      state.verifySmartSuiteAgreement.loading = true;
      state.verifySmartSuiteAgreement.error = null;
    },
    verifySmartSuiteAgreementReset: (state, action) => {
      state.verifySmartSuiteAgreement.loading = false;
      state.verifySmartSuiteAgreement.error = null;
      state.verifySmartSuiteAgreement.data = null;
    },
    verifySmartSuiteAgreementSuccess: (state, action) => {
      state.verifySmartSuiteAgreement.data = action.payload;
      state.verifySmartSuiteAgreement.loading = false;
      state.verifySmartSuiteAgreement.error = null;

      state.agreementList = updateSmartSuiteAgreementListSuccess(
        action.payload,
        state.agreementList
      );
    },
    verifySmartSuiteAgreementFailure: (state, action) => {
      state.verifySmartSuiteAgreement.data = null;
      state.verifySmartSuiteAgreement.loading = false;
      state.verifySmartSuiteAgreement.error = action.payload;
    },
    updateAgreementKycDocumentsRequest: (state, action) => {
      state.updateAgreementKycDocuments.loading = true;
      state.updateAgreementKycDocuments.error = null;
    },
    updateAgreementKycDocumentsSuccess: (state, action) => {
      state.updateAgreementKycDocuments.data = action.payload;
      state.updateAgreementKycDocuments.loading = false;
      state.updateAgreementKycDocuments.error = null;

      state.agreementList = updateKycDocumentsSuccess(
        action.payload,
        state.agreementList
      );
    },
    updateAgreementKycDocumentsFailure: (state, action) => {
      state.updateAgreementKycDocuments.data = null;
      state.updateAgreementKycDocuments.loading = false;
      state.updateAgreementKycDocuments.error = action.payload;
    },

    updateAgreementSignedDocumentRequest: (state, action) => {
      state.updateAgreementSignedDocument.loading = true;
      state.updateAgreementSignedDocument.error = null;
    },
    updateAgreementSignedDocumentSuccess: (state, action) => {
      state.updateAgreementSignedDocument.data = action.payload;
      state.updateAgreementSignedDocument.loading = false;
      state.updateAgreementSignedDocument.error = null;

      state.agreementList = updateSignedDocumentSuccess(
        action.payload,
        state.agreementList
      );
    },
    updateAgreementSignedDocumentFailure: (state, action) => {
      state.updateAgreementSignedDocument.data = null;
      state.updateAgreementSignedDocument.loading = false;
      state.updateAgreementSignedDocument.error = action.payload;
    },
    deleteSmartSuiteAgreementRequest: (state, action) => {
      state.deleteSmartSuiteAgreement.loading = true;
      state.deleteSmartSuiteAgreement.error = null;
    },
    deleteSmartSuiteAgreementSuccess: (state, action) => {
      state.deleteSmartSuiteAgreement.data = action.payload;
      state.deleteSmartSuiteAgreement.loading = false;
      state.deleteSmartSuiteAgreement.error = null;
      state.agreementList = deleteAgreementSuccess(action.payload, {
        ...state.agreementList,
      });
    },
    deleteSmartSuiteAgreementFailure: (state, action) => {
      state.deleteSmartSuiteAgreement.data = null;
      state.deleteSmartSuiteAgreement.loading = false;
      state.deleteSmartSuiteAgreement.error = action.payload;
    },

    expansionSmartSuiteAgreementRequest: (state, action) => {
      state.expansionSmartSuiteAgreement.loading = true;
      state.expansionSmartSuiteAgreement.error = null;
    },
    expansionSmartSuiteAgreementSuccess: (state, action) => {
      state.expansionSmartSuiteAgreement.data = action.payload;
      state.expansionSmartSuiteAgreement.loading = false;
      state.expansionSmartSuiteAgreement.error = null;

      state.agreementList = updateSmartSuiteAgreementListSuccess(
        action.payload,
        state.agreementList
      );
    },
    expansionSmartSuiteAgreementFailure: (state, action) => {
      state.expansionSmartSuiteAgreement.data = null;
      state.expansionSmartSuiteAgreement.loading = false;
      state.expansionSmartSuiteAgreement.error = action.payload;
    },

    fetchAgrExpansionDetailsRequest: (state, action) => {
      state.agrExpansionList.loading = true;
      state.agrExpansionList.error = null;
    },
    fetchAgrExpansionDetailsSuccess: (state, action) => {
      state.agrExpansionList.data = action.payload;
      state.agrExpansionList.loading = false;
      state.agrExpansionList.error = null;
    },
    fetchAgrExpansionDetailsFaliure: (state, action) => {
      state.agrExpansionList.data = null;
      state.agrExpansionList.loading = false;
      state.agrExpansionList.error = action.payload;
    },
    fetchAgreementByIdRequest: (state, action) => {
      state.agreementById.loading = true;
      state.agreementById.error = null;
    },
    fetchAgreementByIdSuccess: (state, action) => {
      state.agreementById.data = action.payload;
      state.agreementById.loading = false;
      state.agreementById.error = null;
    },
    fetchAgreementByIdFailure: (state, action) => {
      state.agreementById.data = null;
      state.agreementById.loading = false;
      state.agreementById.error = action.payload;
    },
    fetchAgreementByIdReset: (state, action) => {
      state.agreementById.data = null;
      state.agreementById.loading = false;
      state.agreementById.error = null;
    },

    // code for Renewal
    createRenewalSmartSuiteAgreementRequest: (state, action) => {
      state.createRenewalSmartSuiteAgreement.loading = true;
      state.createRenewalSmartSuiteAgreement.error = null;
    },
    createRenewalSmartSuiteAgreementSuccess: (state, action) => {
      state.createRenewalSmartSuiteAgreement.data = action.payload;
      state.createRenewalSmartSuiteAgreement.loading = false;
      state.createRenewalSmartSuiteAgreement.error = null;

      // state.agreementList = addRenewalSmartSuiteAgreementListSuccess(
      //   action.payload,
      //   state.agreementList
      // );
    },
    createRenewalSmartSuiteAgreementFailure: (state, action) => {
      state.createRenewalSmartSuiteAgreement.data = null;
      state.createRenewalSmartSuiteAgreement.loading = false;
      state.createRenewalSmartSuiteAgreement.error = action.payload;
    },
    createRenewalSmartSuiteAgreementReset: (state, action) => {
      state.createRenewalSmartSuiteAgreement.data = null;
      state.createRenewalSmartSuiteAgreement.loading = false;
      state.createRenewalSmartSuiteAgreement.error = null;
    },

    updateAgreementDocumentsRequest: (state, action) => {
      state.updateAgreementDocuments.loading = true;
      state.updateAgreementDocuments.error = null;
    },
    updateAgreementDocumentsSuccess: (state, action) => {
      state.updateAgreementDocuments.data = action.payload;
      state.updateAgreementDocuments.loading = false;
      state.updateAgreementDocuments.error = null;

      state.agreementList = updateArgDocumentsSuccess(
        action.payload,
        state.agreementList
      );
    },
    updateAgreementDocumentsFailure: (state, action) => {
      state.updateAgreementDocuments.data = null;
      state.updateAgreementDocuments.loading = false;
      state.updateAgreementDocuments.error = action.payload;
    },
    fetchSmartSuiteAgreementDocumentListRequest: (state, action) => {
      state.agreementDocumentList.loading = true;
      state.agreementDocumentList.error = null;
    },
    fetchSmartSuiteAgreementDocumentListSuccess: (state, action) => {
      state.agreementDocumentList.data = action.payload;
      state.agreementDocumentList.loading = false;
      state.agreementDocumentList.error = null;
    },
    fetchSmartSuiteAgreementDocumentListFailure: (state, action) => {
      state.agreementDocumentList.data = null;
      state.agreementDocumentList.loading = false;
      state.agreementDocumentList.error = action.payload;
    },
    linkAgreementAccountRequest: (state, action) => {
      state.linkAgreementAccount.loading = true;
      state.linkAgreementAccount.error = null;
    },
    linkAgreementAccountSuccess: (state, action) => {
      state.linkAgreementAccount.data = action.payload;
      state.linkAgreementAccount.loading = false;
      state.linkAgreementAccount.error = null;
    },
    linkAgreementAccountFailure: (state, action) => {
      state.linkAgreementAccount.data = null;
      state.linkAgreementAccount.loading = false;
      state.linkAgreementAccount.error = action.payload;
    },

    clientTicketsListRequest: (state, action) => {
      state.clientTicketsList.loading = true;
      state.clientTicketsList.error = null;
    },
    clientTicketsListSuccess: (state, action) => {
      state.clientTicketsList.data = action.payload;
      state.clientTicketsList.loading = false;
      state.clientTicketsList.error = null;
    },
    clientTicketsListFailure: (state, action) => {
      state.clientTicketsList.data = null;
      state.clientTicketsList.loading = false;
      state.clientTicketsList.error = action.payload;
    },
    requestMoveInEmailSend: (state, action) => {
      state.moveInEmailSend.loading = true;
      state.moveInEmailSend.error = null;
    },
    moveInEmailSendSuccess: (state, action) => {
      state.moveInEmailSend.data = action.payload;
      state.moveInEmailSend.loading = false;
      state.moveInEmailSend.error = null;
    },
     moveInEmailSendFailure: (state, action) => {
      state.moveInEmailSend.data = null;
      state.moveInEmailSend.loading = false;
      state.moveInEmailSend.error = action.payload;
    },
    requestIsNoticeEmailSend: (state, action) => {
      state.isNoticeEmailSend.loading = true;
      state.isNoticeEmailSend.error = null;
    },
    IsNoticeEmailSendSuccess: (state, action) => {
      state.isNoticeEmailSend.data = action.payload;
      state.isNoticeEmailSend.loading = false;
      state.isNoticeEmailSend.error = null;
    },
    IsNoticeEmailSendFailure: (state, action) => {
      state.isNoticeEmailSend.data = null;
      state.isNoticeEmailSend.loading = false;
      state.isNoticeEmailSend.error = action.payload;
    },
  },
});
function addSmartSuiteAgreementListSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((value) => {
    if (value._id !== dataToUpdate._id) return value;
    return { ...value, ...dataToUpdate };
  });

  return state;
}
function updateSmartSuiteAgreementListSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((value) => {
    if (value._id !== dataToUpdate._id) return value;
    return { ...value, ...dataToUpdate };
  });

  return state;
}
function updateKycDocumentsSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((value) => {
    if (value._id !== dataToUpdate._id) return value;
    return { ...value, ...dataToUpdate };
  });

  return state;
}

function updateSignedDocumentSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((value) => {
    if (value._id !== dataToUpdate._id) return value;
    return { ...value, ...dataToUpdate };
  });

  return state;
}

// Function for Renewal
function addRenewalSmartSuiteAgreementListSuccess(dataToUpdate, state) {
  console.log("state",state);
  state.data.data = state?.data?.data?.map((value) => {
    if (value._id !== dataToUpdate._id) return value;
    return { ...value, ...dataToUpdate };
  });

  return state;
}

function deleteAgreementSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.filter((target) => {
    return target._id != dataToUpdate.data;
  });
  return state;
}

function updateArgDocumentsSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((value) => {
    if (value._id !== dataToUpdate._id) return value;
    return { ...value, ...dataToUpdate };
  });

  return state;
}

export const {
  fetchLienListRequest,
  fetchLienListSuccess,
  fetchLienListError,
  fetchEntityNamesRequest,
  fetchEntityNamesSuccess,
  fetchEntityNamesFailure,
  fetchAgreementsByEntityRequest,
  fetchAgreementsByEntitySuccess,
  fetchAgreementsByEntityFailure,
  fetchAgreementsByEntityReset,
  fetchClientAgreementListRequest,
  fetchClientAgreementListSuccess,
  fetchClientAgreementListFailure,
  fetchClientAgreementListReset,
  fetchSmartSuiteAgreementListRequest,
  fetchSmartSuiteAgreementListSuccess,
  fetchSmartSuiteAgreementListFaliure,
  fetchAllSmartSuiteAgreementListFaliure,
  fetchAllSmartSuiteAgreementListSuccess,
  fetchAllSmartSuiteAgreementListRequest,
  fetchSmartSuiteAgreementListRequestLog,
  fetchSmartSuiteAgreementListLogSuccess,
  fetchSmartSuiteAgreementListLogFaliure,
  resetSmartSuiteAgreementListLog,
  createSmartSuiteAgreementRequest,
  createSmartSuiteAgreementSuccess,
  createSmartSuiteAgreementFailure,
  createSmartSuiteAgreementReset,
  updateSmartSuiteAgreementRequest,
  updateSmartSuiteAgreementSuccess,
  updateSmartSuiteAgreementFailure,
  updateSmartSuiteAgreementReset,
  verifySmartSuiteAgreementFailure,
  verifySmartSuiteAgreementSuccess,
  verifySmartSuiteAgreementRequest,
  verifySmartSuiteAgreementReset,
  updateAgreementKycDocumentsRequest,
  updateAgreementKycDocumentsFailure,
  updateAgreementKycDocumentsSuccess,
  updateAgreementSignedDocumentRequest,
  updateAgreementSignedDocumentFailure,
  updateAgreementSignedDocumentSuccess,
  deleteSmartSuiteAgreementRequest,
  deleteSmartSuiteAgreementSuccess,
  deleteSmartSuiteAgreementFailure,
  expansionSmartSuiteAgreementRequest,
  expansionSmartSuiteAgreementSuccess,
  expansionSmartSuiteAgreementFailure,
  fetchAgrExpansionDetailsRequest,
  fetchAgrExpansionDetailsSuccess,
  fetchAgrExpansionDetailsFailure,
  fetchAgreementByIdRequest,
  fetchAgreementByIdSuccess,
  fetchAgreementByIdFailure,
  fetchAgreementByIdReset,
  createRenewalSmartSuiteAgreementRequest,
  createRenewalSmartSuiteAgreementSuccess,
  createRenewalSmartSuiteAgreementFailure,
  createRenewalSmartSuiteAgreementReset,
  updateAgreementDocumentsRequest,
  updateAgreementDocumentsSuccess,
  updateAgreementDocumentsFailure,
  fetchSmartSuiteAgreementDocumentListRequest,
  fetchSmartSuiteAgreementDocumentListSuccess,
  fetchSmartSuiteAgreementDocumentListFailure,
  linkAgreementAccountRequest,
  linkAgreementAccountSuccess,
  linkAgreementAccountFailure,
  clientTicketsListRequest,
  clientTicketsListSuccess,
  clientTicketsListFailure,
  IsNoticeEmailSendFailure,
  IsNoticeEmailSendSuccess,
  requestIsNoticeEmailSend,
  moveInEmailSendFailure,
  moveInEmailSendSuccess,
  requestMoveInEmailSend
} = AgreementSlice.actions;

/**
 *
 * @param {*} store
 * @returns {SmartSuiteAgreementsListState}
 */
export const getSmartSuiteAgreementsListState = (state) =>
  state.smartSuiteAgreements?.agreementList;
  export const getSmartSuiteAgreementsListLogState = (state) =>
  state.smartSuiteAgreements?.agreementLog;
/**
 *
 * @param {*} state
 * @returns {SmartSuiteAgreementsListState['createSmartSuiteAgreement']}
 */
export const getCreateSmartSuiteAgreementState = (state) =>
  state.smartSuiteAgreements.createSmartSuiteAgreement;
export const getEmailSendSuiteAgreementState = (state) =>
  state.moveInEmailSend.createSmartSuiteAgreement;
export const getRenewSmartSuiteAgreementState = (state) =>
  state.smartSuiteAgreements.createRenewalSmartSuiteAgreement;

/**
 *
 * @param {*} state
 * @returns {SmartSuiteAgreementsListState['updateSmartSuiteAgreement']}
 */
export const getUpdateSmartSuiteAgreementState = (state) =>
  state.smartSuiteAgreements?.updateSmartSuiteAgreement;
export const getVerifySmartSuiteAgreementState = (state) =>
  state.smartSuiteAgreements?.verifySmartSuiteAgreement;

  export const getLienListState = (state)=> state.smartSuiteAgreements.lienList;
  export const getEntityNamesState = (state)=> state.smartSuiteAgreements.entityNames;
  export const getAgreementsByEntityState = (state)=> state.smartSuiteAgreements.agreementsByEntity;
  export const getClientAgreementListState = (state)=> state.smartSuiteAgreements.clientAgreementList;
/**
 *
 * @param {*} state
 * @returns {SmartSuiteAgreementsListState['linkAgreementAccount']}
 */
export const getLinkAgreementAccountState = (state) =>
  state.smartSuiteAgreements?.linkAgreementAccount;


  export const getClientTicketListState = (state) =>
  state.smartSuiteAgreements?.clientTicketsList;

/**
 *
 * @param {*} state
 * @returns {SmartSuiteAgreementsListState['updateAgreementKycDocument']}
 */
export const getUpdateAgreementKycDocumentsState = (state) =>
  state.smartSuiteAgreements?.updateAgreementKycDocuments;

/**
 *
 * @param {*} state
 * @returns {SmartSuiteAgreementsListState['updateSignedAgreementDocument']}
 */
export const getUpdateSignedAgreementsState = (state) =>
  state.smartSuiteAgreements?.updateAgreementSignedDocument;

/**
 *
 * @param {*} store
 * @returns {AgreementByIdState}
 */
export const getAgreementByIdState = (state) =>
  state.smartSuiteAgreements?.agreementById;

/**
 *
 * @param {*} state
 * @returns {SmartSuiteAgreementsListState['createSmartSuiteAgreement']}
 */
export const getDeleteSmartSuiteAgreementState = (state) =>
  state.deleteSmartSuiteAgreement;

/**
 *
 * @param {*} state
 * @returns {SmartSuiteAgreementsListState['updateSmartSuiteAgreement']}
 */
export const getExpansionSmartSuiteAgreementState = (state) =>
  state.smartSuiteAgreements?.expansionSmartSuiteAgreement;

/**
 *
 * @param {*} store
 * @returns {SmartSuiteAgreementsListState}
 */
export const getAgrExpansionDetailsState = (state) =>
  state.smartSuiteAgreements?.agrExpansionList;

/**
 *
 * @param {*} state
 * @returns {SmartSuiteAgreementsListState['updateAgreementDocument']}
 */
export const getUpdateAgreementDocumentsState = (state) =>
  state.smartSuiteAgreements?.updateAgreementDocuments;

export const getSmartSuiteAgreementsDocumentListState = (state) =>
  state.smartSuiteAgreements?.agreementDocumentList;
export default AgreementSlice.reducer;
